<template>
  <div
    class="hcl-modal"
    v-if="modalIsOpen"
  >
    <div
      class="modal fade show d-block"
      aria-modal="true"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <slot name="header">
              <h4 class="modal-title">
                <slot name="title"></slot>
              </h4>
            </slot>
            <button
              type="button"
              class="btn btn-link"
              data-dismiss="modal"
              aria-label="Close"
              @click="onAbort"
            >
              <i
                aria-hidden="true"
                class="eii--fa6-solid--xmark"
              ></i>
            </button>
          </div>
          <div class="modal-body">
            <slot :modalIsOpen="modalIsOpen"></slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
            </slot>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

interface Props {
  /**
   * Should modal be open initially?
   */
  open?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  open: false
})

const emit = defineEmits(['modal-abort'])

const modalIsOpen = ref(props.open)

watch(
  () => props.open,
  (n) => {
    modalIsOpen.value = n
  }
)

const onAbort = () => {
  emit('modal-abort')
}
</script>
